import Crud from '../components/Dimension/Crud'

let routes = {
    path: '/dimensions',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
      {
          path: '/dimensions/:operation?/:id?',
          name: 'Dimensões',
          component: Crud
      },
    ]
}

export default routes


// WEBPACK FOOTER //
// ./src/router/dimension.js